import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileDownload2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.75 4.75h-5a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2h.5m4.5-14.5v3.5a2 2 0 0 0 2 2h3.5m-5.5-5.5 5.5 5.5m0 0v7a2 2 0 0 1-2 2h-.5M12 13.75v5.5M9.75 16.75l2.25 2.5 2.25-2.5"
    />
  </svg>
);
export default SvgFileDownload2;
